// Contao und Isotope setzen als alt-Text teils den Dateipfad ein
// ("files/Dateien/...") - fuer Screenreader und Bildersuche wertlos.
// Wo es eine Ueberschrift im selben Block gibt, tritt sie an die Stelle.

document.querySelectorAll('.cart-row').forEach((zeile) => {
    const bild = zeile.querySelector('.cart-col.image img');
    const name = zeile.querySelector('.cart-col.name a');

    if (bild && name) {
        bild.alt = name.textContent.trim();
    }
});

document.querySelectorAll('img[alt]').forEach((bild) => {
    if (!/^(files|isotope|assets)\//.test(bild.alt)) {
        return;
    }

    const block = bild.closest('.container-inner, figure, .image') || bild.parentElement;
    const titel = block && block.querySelector('h1, h2, h3, h4, h5, h6');

    bild.alt = titel ? titel.textContent.trim() : '';
});
